<template>
  <b-card
    no-body
    :class="{'open': visible}"
    @mouseenter="collapseOpen"
    @mouseleave="collapseClose"
  >
    <b-card-header
      :class="{'collapsed': !visible}"
      :aria-expanded="visible ? 'true' : 'false'"
      :aria-controls="collapseItemID"
      role="tab"
      data-toggle="collapse"
      @click.stop="updateVisible(!visible)"
    >
      <slot name="header">
        <span class="lead collapse-title">{{ title }}</span>
      </slot>
      <b-button
        v-if="data && data.reports_exists"
        variant="success"
        class="p-0 px-1 d-flex align-items-center justify-content-center"
        style="height: 1.8rem;"
        @click.stop="exportExcel"
      >
        <!-- @click="updateVisible(!visible)" -->
        <b-spinner
          v-if="loader"
          style="margin-right: 5px;"
          small
          variant="light"
        />
        <span v-else>
          <feather-icon
            style="margin-right: 5px;"
            icon="DownloadIcon"
          />
        </span>
        Excel
      </b-button>
    </b-card-header>

    <b-collapse
      :id="collapseItemID"
      v-model="visible"
      :accordion="accordion"
      role="tabpanel"
    >
      <b-card-body>
        <slot />
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import {
  BCard,
  BCardHeader,
  BCardBody,
  BCollapse,
  BButton,
  BSpinner,
} from 'bootstrap-vue'
import { v4 as uuidv4 } from 'uuid'
import { mapActions } from 'vuex'

export default {
  components: {
    BCard,
    BCardHeader,
    BCardBody,
    BCollapse,
    BButton,
    BSpinner,
  },
  props: {
    isVisible: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      required: true,
    },
    data: {
      type: Object,
      required: true,
    },
    // loader: {
    //   type: Boolean,
    //   default: false,
    // },
  },
  data() {
    return {
      visible: false,
      collapseItemID: '',
      openOnHover: this.$parent.hover,
      loader: false,
    }
  },
  computed: {
    accordion() {
      return this.$parent.accordion
        ? `accordion-${this.$parent.collapseID}`
        : null
    },
  },
  created() {
    this.collapseItemID = uuidv4()
    this.visible = this.isVisible
  },
  methods: {
    ...mapActions('objects', ['FETCH_OBJECTS', 'EXCEL_UPLOAD']),
    updateVisible(val = true) {
      this.visible = val
      this.$emit('visible', val)
    },
    collapseOpen() {
      if (this.openOnHover) this.updateVisible(true)
    },
    collapseClose() {
      if (this.openOnHover) this.updateVisible(false)
    },
    // exportExcel() {
    //   this.$emit('export-excel', this.data.id)
    // },
    exportExcel() {
      this.loader = true
      this.EXCEL_UPLOAD(this.data.id)
        .then(res => {
          const url = window.URL.createObjectURL(new Blob([res.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'file.xlsx')
          document.body.appendChild(link)
          link.click()

          this.$nextTick(() => {
            this.$_successToast(this.$t('clients.file_uploaded_successfully'))
          })
        })
        .catch(err => {
          console.log(err)
          this.$_errorToast(this.$t('generals.error'))
        })
        .finally(() => {
          this.loader = false
        })
    },
  },
}
</script>
